// extracted by mini-css-extract-plugin
export default {"pool":"pool___oET_S","poolLabels":"poolLabels___D14RT","label1":"label1___A7hFG","label2":"label2___VPze_","label3":"label3___FFzyr"};